/**
 * @generated SignedSource<<b8bbbe79fbb517d6e33c690981a94e58>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutPaymentStepSubmit_viewer$data = {
  readonly stripeIsEnabled: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutBankAccountsSubmitStripe_viewer" | "CheckoutBankAccountsSubmit_viewer" | "CheckoutCreditCardSubmit_viewer">;
  readonly " $fragmentType": "CheckoutPaymentStepSubmit_viewer";
};
export type CheckoutPaymentStepSubmit_viewer$key = {
  readonly " $data"?: CheckoutPaymentStepSubmit_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutPaymentStepSubmit_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutPaymentStepSubmit_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutCreditCardSubmit_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutBankAccountsSubmit_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutBankAccountsSubmitStripe_viewer"
    },
    {
      "alias": "stripeIsEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "stripeCheckout"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"stripeCheckout\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "cd76a6ac99a4676b59abcee868d619a7";

export default node;
